module.exports = __webpack_public_path__ + "img/stu-female.2e95a000.png";